import type { ModalPromptProps } from "@/components/modal/ModalPrompt";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface PromptStoreState
	extends Pick<ModalPromptProps, "title" | "description"> {
	/**
	 * @default false
	 */
	isOpen: boolean;
	positiveButton: ModalPromptProps["positiveButtonProps"];
	negativeButton: ModalPromptProps["negativeButtonProps"];
}

interface PromptStoreActions {
	open: (payload?: Partial<Omit<PromptStoreState, "open">>) => void;
	close: () => void;
}

type PromptStore = PromptStoreState & PromptStoreActions;

const initialState: PromptStoreState = {
	isOpen: false,
	title: "",
	description: "",
	// @ts-expect-error
	positiveButton: {},
	negativeButton: { label: "Cancel" },
};

export const usePrompt = create<PromptStore>()(
	devtools((set) => ({
		...initialState,
		open: (payload) =>
			set(
				{
					isOpen: true,
					title: payload?.title ?? initialState.title,
					description: payload?.description ?? initialState.description,
					positiveButton:
						payload?.positiveButton ?? initialState.positiveButton,
					negativeButton:
						payload?.negativeButton ?? initialState.negativeButton,
				},
				undefined,
				"store:loadingOverlay/open",
			),
		close: () => set(initialState, undefined, "store:loadingOverlay/close"),
	})),
);
